import { yupResolver } from '@hookform/resolvers/yup';
import { Grid } from '@mui/material';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { addInventorySchema, addInventorySchemaRequired } from 'src/config/yup';
import CustomTextField from '../formFields/textField';
import { t } from 'i18next';
import LoaderButton from '../loaderButton/loaderButton';
import { CREATE_INVENTORY_ITEM, UPDATE_INVENTORY_ITEM } from 'src/apiService/apiDeclaration';
import { showErrorTost, showSuccessTost } from 'src/constants';

const AddInventoryForm = ({ onSuccess, data, stockAdd = true }) => {
  const [loading, setLoading] = useState(false);
  const {
    handleSubmit,
    control,
    formState: { errors, isValid, isDirty },
  } = useForm({
    mode: 'onChange',
    resolver: yupResolver(!stockAdd ? addInventorySchemaRequired : addInventorySchema),
    defaultValues: {
      ...data,
      stockAdd: stockAdd,
      concrete: !stockAdd && data.volumeOfConcrete,
    },
  });

  const onSubmit = async (body) => {
    setLoading(true);

    if (data?.orderNumber) {
      body = {
        stockAdd: stockAdd,
        cement: body.cement,
        sand: body.sand,
        gravel815: body.gravel815,
        gravel1525: body.gravel1525,
        concrete: body.concrete,
        orderNumber: data.orderNumber,
        subOrderNumber: data.subOrderNumber,
        orderId: data.orderId,
        subOrderId: data._id,
      };
    }

    try {
      let resp;
      if (data && stockAdd) {
        resp = await UPDATE_INVENTORY_ITEM(data.id, body);
      } else {
        if (!data?.orderNumber) {
          delete body.concrete;
        }
        resp = await CREATE_INVENTORY_ITEM(body);
      }
      showSuccessTost(resp.message);
      onSuccess();
    } catch (error) {
      showErrorTost(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            label={t('inventoryPage.cement')}
            type="number"
            controller={{
              name: 'cement',
              control: control,
              errors: !stockAdd && errors.cement,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            label={t('inventoryPage.sand')}
            type="number"
            controller={{
              name: 'sand',
              control: control,
              errors: !stockAdd && errors.sand,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            label={t('inventoryPage.gravel815')}
            type="number"
            controller={{
              name: 'gravel815',
              control: control,
              errors: !stockAdd && errors.gravel815,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <CustomTextField
            label={t('inventoryPage.gravel1525')}
            type="number"
            controller={{
              name: 'gravel1525',
              control: control,
              errors: !stockAdd && errors.gravel1525,
            }}
          />
        </Grid>
        {!stockAdd && (
          <Grid item xs={12} sm={6}>
            <CustomTextField
              label={t('inventoryPage.concrete')}
              type="number"
              disabled
              controller={{
                name: 'concrete',
                control: control,
                errors: errors.concrete,
              }}
            />
          </Grid>
        )}
        <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Grid item xs={12} sm={6}>
            <LoaderButton
              type="submit"
              buttonText={stockAdd ? t('inventoryPage.addInventory') : t('orderDetailsPage.prepareOrder')}
              disabled={!isDirty || !isValid}
              loading={loading}
            />
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

export default AddInventoryForm;
